import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatisticsComponent } from './statistics.component';
import { Routes, RouterModule } from '@angular/router';
import { OverallComponent } from './overall/overall.component';
import { OnlineExamsComponent } from './online-exams/online-exams.component';
import { TermTestsComponent } from './term-tests/term-tests.component';
import { RevisionPapersComponent } from './revision-papers/revision-papers.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SubjectProgressComponent } from './shared/subject-progress/subject-progress.component';
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ChartsModule,
    SharedModule
  ],
  declarations: [
    StatisticsComponent,
    OverallComponent,
    OnlineExamsComponent,
    TermTestsComponent,
    RevisionPapersComponent,
    SubjectProgressComponent
  ],
  providers: []

})
export class StatisticsModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/statistics/statistics.module.ts